import UsersService from "@/services/common/UsersService";
import DateTimeHandlerService from "@/services/common/date-time/DateTimeHandlerService";
import { RESET_STATE, SET } from "@/stores/CommumActionTypes.js";

const mutations = {
	[SET]: (state, userPreferences) =>
	{
		state.userPreferences.language = userPreferences.language;
		state.userPreferences.theme = userPreferences.theme;
		state.userPreferences.timeZone.name = userPreferences.timeZone;
		state.userPreferences.timeZone.offset = DateTimeHandlerService.GetLongOffsetFromIntl(userPreferences.timeZone);
	},
	[RESET_STATE]: (state) =>
	{
		state = UsersService.EmptyUserPreferencesStateFactory();
	},
};

export default { mutations };
